export enum TextFieldName {
  Space = 'spaceId',
  Title = 'title',
  Teaser = 'teaser',
  Image = 'image',
  EffortHours = 'effortHours',
  EffortMinutes = 'effortMinutes',
  Level = 'level',
  Visiblity = 'visibility',
  Language = 'language',
  Subject = 'subjectId',
  ContentOwner = 'contentOwnerId',
  Attributes = 'attributes',
  UserRoleConnections = 'userRoleConnections',
}

export const LEVELS = ['Basic', 'Intermediate', 'Advanced'];
